import type {
  CreateAsaasAccountDto,
  QueryAsaasAccountsDto,
  UpdateAsaasAccountDto,
} from '@control-center/shared';

import { apiClient } from './api-client';

export interface AsaasAccountView {
  id: string;
  name: string;
  environment: 'sandbox' | 'production';
  webhookPath: string;
  isDefault: boolean;
  status: 'active' | 'paused' | 'disabled';
  lateFeeConfig: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
  api_key_masked: string;
  webhook_secret_masked: string;
  webhook_url: string;
}

interface SingleResponse {
  data: AsaasAccountView;
}

interface ListResponse {
  items: AsaasAccountView[];
}

export async function fetchAsaasAccounts(
  params: QueryAsaasAccountsDto = {},
): Promise<AsaasAccountView[]> {
  const { data } = await apiClient.get<ListResponse>('/api/asaas-accounts', { params });
  return data.items;
}

export async function fetchAsaasAccount(id: string): Promise<AsaasAccountView> {
  const { data } = await apiClient.get<SingleResponse>(`/api/asaas-accounts/${id}`);
  return data.data;
}

export async function createAsaasAccount(
  payload: CreateAsaasAccountDto,
): Promise<AsaasAccountView> {
  const { data } = await apiClient.post<SingleResponse>('/api/asaas-accounts', payload);
  return data.data;
}

export async function updateAsaasAccount(
  id: string,
  payload: UpdateAsaasAccountDto,
): Promise<AsaasAccountView> {
  const { data } = await apiClient.patch<SingleResponse>(`/api/asaas-accounts/${id}`, payload);
  return data.data;
}

export async function disableAsaasAccount(id: string): Promise<void> {
  await apiClient.delete(`/api/asaas-accounts/${id}`);
}
